import React from "react";
import Collapse, { CollapsePanel } from "../ui/Collapse";
import "./GMBScoring.css";
import LockOverview from "./LockOverview";

const ValidCriteria = ({ valid, hasFullAccess }) => {
  if (!valid || valid.length === 0) {
    return (
      <div className="audit-section" style={{ marginTop: 24 }}>
        <div className="audit-section__header">
          <span className="audit-section__badge audit-section__badge--green">0</span>
          <h4 className="audit-section__title">Critères optimisés</h4>
        </div>
        <p className="audit-section__empty">Aucun critère optimisé détecté</p>
      </div>
    );
  }

  const visibleValid = hasFullAccess ? valid : valid.slice(0, 3);

  return (
    <div className="audit-section" style={{ marginTop: 24 }}>
      <div className="audit-section__header">
        <span className="audit-section__badge audit-section__badge--green">{valid.length}</span>
        <h4 className="audit-section__title">Critères optimisés</h4>
      </div>
      <Collapse>
        {visibleValid.map((val, i) => (
          <CollapsePanel
            header={val.header}
            extra={<span className="audit-section__status audit-section__status--valid">Validé</span>}
            key={val.header}
            defaultOpen={i === 0}
          >
            <p className="audit-section__content">{val.content}</p>
          </CollapsePanel>
        ))}
      </Collapse>
      {!hasFullAccess && valid.length > 3 && (
        <LockOverview isIssue={false} />
      )}
    </div>
  );
};

export default ValidCriteria;
